import { defaultRows } from "../../constants/rows";
import { IAction } from "../action";
import { actionTypes } from "../actions";
export function getStartWithRow(state, action) {
    if (state === void 0) { state = defaultRows.offset; }
    switch (action.type) {
        case actionTypes.loadScopeNames:
            if (action.payload) {
                return state;
            }
            return defaultRows.offset;
        case actionTypes.dataModelNamesLoaded:
            return defaultRows.offset;
        case actionTypes.changeStartWithRow:
            return action.payload;
        default:
            return state;
    }
}
